
export default class TimerRoute{

    constructor(attrs) {
        this.create = 'timer';
        this.update = 'timer/'+attrs['id'];
    }

}
